import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 導入 i18n 配置 - 必須在 App 之前導入
import './i18n/config'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
